import * as modal from "./modal.ts";
import TPL from '../filer/modal_progress.mustache'

export function newMultiBar(fileCount :number){
  var
    data = {rate:0,partialRate:0},
    i = 0,
    theModal = modal.openDomModal(TPL,{}),
    mainRateNode = theModal.querySelector('.pgbar-panel-rate') as HTMLElement,
    subRateNode = theModal.querySelector('.pgbar-panel-partialrate') as HTMLElement,
    mainRateTextNode = theModal.querySelector('.pgbar-panel-rate-text') as HTMLElement;

  function maj(){
    mainRateNode.style.strokeDashoffset = (100-100*data.rate).toString()
    if(subRateNode){
      if(data.partialRate===0){
        subRateNode.style.transition = 'unset'
      }else{
        subRateNode.style.transition = 'all ease 0.5s'
      }
      subRateNode.style.strokeDashoffset = (100-100*data.partialRate).toString()

    }
    mainRateTextNode.innerHTML = (100*data.rate).toFixed(1)+'%'

  }
  return {
    subProgress(){
      return {
        progress(rate){
          data.partialRate = rate;
          data.rate = (i+rate)/fileCount
          maj();
        },
        close(){
          data.rate = (i)/fileCount;
          data.partialRate = 0;
          i++;
          maj();
        }
      }
    },
    close(){
      modal.closeDomModal(theModal)
    }

  }
}
export function newMultiBarSimple(todoCount :number){
  var
    data :number[] = new Array(todoCount),
    i = 0,
    theModal = modal.openDomModal(TPL,{}),
    mainRateNode = theModal.querySelector('.pgbar-panel-rate') as HTMLElement,
    mainRateTextNode = theModal.querySelector('.pgbar-panel-rate-text') as HTMLElement;

  data.fill(0);
  function getRate(){
    return data.reduce((prev,current)=>prev+current,0)/todoCount;
  }
  function maj(){
    var rate = getRate()
    mainRateNode.style.strokeDashoffset = (100-100*rate).toString()
    mainRateTextNode.innerHTML = (100*rate).toFixed(1)+'%'
  }
  return {
    subProgress(){
      var idx = i;
      i++;
      return {
        progress(rate){
          data[idx] = rate;
          maj();
        },
        close(){
          data[idx] = 1;
          maj();
        }
      }
    },
    close(){
      modal.closeDomModal(theModal)
    }
  }
}